import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import folderStore from 'owa-folders';
// Same order as in OWA:MailFolderTreeNodeViewModel.cs
var FOLDERS_TO_SHOW_FIRST = [
    'inbox',
    'junkemail',
    'drafts',
    'sentitems',
    'deleteditems',
];
var GEEK_FOLDERS_TO_HIDE = ['journal', 'outbox', 'syncissues'];
var FOLDER_DELIMITER = '\\';
// returns the flat folder tree to be used in the move to dropdown
export default function getContextMenuFolders() {
    // Get flat folder tree
    var folderList = [];
    // First get the first level of the tree in order, with special folders first
    var childFolderIds = getFirstLevelFoldersInOrder();
    // recursively add all of the child folders of the root
    addAllChildFolders(folderList, childFolderIds, '');
    return folderList;
}
function getFirstLevelFoldersInOrder() {
    var childFolderIds = [];
    var rootFolder = folderStore.rootFolder;
    // First add all the special folders.
    FOLDERS_TO_SHOW_FIRST.forEach(function (distinguishedFolderId) {
        var folder = folderStore.folderTable.get(folderNameToId(distinguishedFolderId));
        if (folder && shouldDisplayFolderInFolderTree(folder)) {
            childFolderIds.push(folder.FolderId.Id);
        }
    });
    // Add all the remaining folders that are not part of the special list above.
    if (rootFolder && rootFolder.childFolderIds) {
        rootFolder.childFolderIds.map(function (childId) {
            var folder = folderStore.folderTable.get(childId);
            if (folder &&
                FOLDERS_TO_SHOW_FIRST.indexOf(folderIdToName(folder.FolderId.Id)) == -1 &&
                shouldDisplayFolderInFolderTree(folder)) {
                childFolderIds.push(folder.FolderId.Id);
            }
        });
    }
    return childFolderIds;
}
// Recursive function to add all child folders in tree for dropdown list
function addAllChildFolders(folderList, childFolders, currentPath) {
    for (var _i = 0, childFolders_1 = childFolders; _i < childFolders_1.length; _i++) {
        var childFolderId = childFolders_1[_i];
        var childFolder = folderStore.folderTable.get(childFolderId);
        // Don't add hidden folders or special folders(they are already added) to list
        if (shouldDisplayFolderInFolderTree(childFolder)) {
            var childFolderPath = currentPath + childFolder.DisplayName;
            var parentFolder = folderStore.folderTable.get(childFolder.ParentFolderId.Id);
            var parentFolderDisplayName = parentFolder ? parentFolder.DisplayName : '';
            var childFolderRuleType = createRuleFolderFromFolderType(childFolder, childFolderPath, parentFolderDisplayName);
            folderList.push(childFolderRuleType);
            if (childFolder.childFolderIds) {
                addAllChildFolders(folderList, childFolder.childFolderIds, childFolderPath + FOLDER_DELIMITER);
            }
        }
    }
}
function isOfTypeMailFolder(folder) {
    return folder && folder.__type == 'Folder:#Exchange';
}
function shouldDisplayFolderInFolderTree(folder) {
    // Do not show the folder if it's not a mail folder.
    if (!isOfTypeMailFolder(folder)) {
        return false;
    }
    var folderName = folderIdToName(folder.FolderId.Id);
    // Suppress hidden and 'geek' folders (outbox, journal, etc).
    if (folder.isHidden || GEEK_FOLDERS_TO_HIDE.indexOf(folderName) >= 0) {
        return false;
    }
    // Only show the Notes folder if that feature is enabled.
    var userConfiguration = getUserConfiguration();
    if (folderName == 'notes') {
        return (userConfiguration.SegmentationSettings.StickyNotes &&
            isMailFeatureEnabled('cal-stickyNotesFolder'));
    }
    // Only show the Junk Email folder if that feature is enabled.
    if (folderName == 'junkemail' && !userConfiguration.SegmentationSettings.JunkEMail) {
        return false;
    }
    // Good folder!
    return true;
}
function createRuleFolderFromFolderType(folderToConvert, currentPath, parentFolderDisplayName) {
    return {
        folderId: folderToConvert.FolderId.Id,
        displayName: folderToConvert.DisplayName,
        parentFolderId: folderToConvert.ParentFolderId.Id,
        parentFolderDisplayName: parentFolderDisplayName,
        childFolderIds: folderToConvert.childFolderIds,
        folderType: folderToConvert.__type,
        isHidden: folderToConvert.isHidden,
        path: currentPath,
    };
}
//# sourceMappingURL=getContextMenuFolders.js.map